import { ProjectResourceCalculationsAssignmentBase } from './base/project-resource-calculations-assignment-base';

export class ProjectResourceCalculationsAssignment extends ProjectResourceCalculationsAssignmentBase { }